<template>
  <div v-if="vehicle" class="equipments">
    <template v-for="group in vehicle.equipments_groups" :key="group">
      <div v-if="Object.keys(group.equipments[type]).length" class="group">
        <div class="group__title">{{ group.label }}</div>
        <div
          v-for="equipment in group.equipments[type]"
          :key="equipment"
          class="equipment"
        >
          {{ equipment.label }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useMainStore } from "@/store";

export default {
  name: "VehicleOptionsTabComponent",
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState(useMainStore, {
      vehicle: (store) => store.vehicle,
    }),
  },
};
</script>

<style lang="scss" scoped>
.group {
  &__title {
    font-weight: 700;
    color: $blue;
    text-transform: uppercase;
    border-bottom: 6px solid $blue;
    padding: 5px 15px;
    font-size: 20px;
  }
}

.group + .group {
  margin-top: 8px;
}

.equipment {
  padding: 8px 15px;

  &:nth-child(odd) {
    background: $white;
  }
}
</style>
